import { AttentionPlace } from "@models/attention-place.model";
import { Financiador, Prestador, TipoTransaccion } from "@models/config.model";
import { InstallationCodeResponse, UserInstallationResponse } from "@models/installation.model";
import { ActualUser } from "@models/user.model";
import * as startData from '@models/start-data.model';
import { ExtraData } from "@models/extra-data.model";

export class InitialData {
    financiadores: Array<Financiador> | null;
    prestadorDTOs: Array<Prestador> | null;
    tipoTransaccion: Array<TipoTransaccion> | null;
    cuitUsuarioInstalacion: string | null;

    constructor(
        financiadores: Array<Financiador>,
        prestadorDTOs: Array<Prestador>,
        tipoTransaccion: Array<TipoTransaccion>,
        cuitUsuarioInstalacion: string
    ) {
        this.financiadores = financiadores;
        this.prestadorDTOs = prestadorDTOs;
        this.tipoTransaccion = tipoTransaccion;
        this.cuitUsuarioInstalacion = cuitUsuarioInstalacion;
    }
}

export class InstallationState {
    public userInstallation: UserInstallationResponse | null;
    public attentionPlaceSelected: AttentionPlace | null;
    public attentionPlaces: Array<AttentionPlace>;


    constructor(
        userInstallation: UserInstallationResponse,
        attentionPlaceSelected: AttentionPlace,
        attentionPlaces: Array<AttentionPlace>,

    ) {
        this.userInstallation = userInstallation;
        this.attentionPlaceSelected = attentionPlaceSelected;
        this.attentionPlaces = attentionPlaces;

    }
}

export class ConfigurationState {
    public installationCode: Array<InstallationCodeResponse> | null;
    public actualUser: ActualUser | null;
    public initialData: InitialData | null;

    constructor(
        installationCode: Array<InstallationCodeResponse> | null,
        actualUser: ActualUser | null,
        initialData: InitialData | null,
    ) {
        this.installationCode = installationCode;
        this.actualUser = actualUser;
        this.initialData = initialData;
    }
}


export class StartDataState {
    public CredencialRequest: startData.CredencialRequestModel | null;
    public FinanciadorRequest: startData.FinanciadorRequestModel | null;
    public PrestadorRequest: startData.PrestadorRequestModel | null;
    public TransaccionRequest: startData.TransaccionRequestModel | null;
    public AfiliadoRequest: startData.AfiliadoRequestModel | null;
    public PatientRequest: any | null;

    constructor(
        CredencialRequest: startData.CredencialRequestModel,
        FinanciadorRequest: startData.FinanciadorRequestModel,
        PrestadorRequest: startData.PrestadorRequestModel,
        TransaccionRequest: startData.TransaccionRequestModel,
        AfiliadoRequest: startData.AfiliadoRequestModel,
        PatientRequest: any
    ) {
        this.CredencialRequest = CredencialRequest;
        this.FinanciadorRequest = FinanciadorRequest;
        this.PrestadorRequest = PrestadorRequest;
        this.TransaccionRequest = TransaccionRequest;
        this.AfiliadoRequest = AfiliadoRequest;
        this.PatientRequest = PatientRequest;
    }
}



export interface Prestacion {
    codigo: string;
    descripcion: string;
}

export interface PrestacionAgregada {
    prestacion: Prestacion;
    cantidad: number;
    tipoPrestacion: string;
    arancel: string;
    numeroAutorizacion: string;
}

export interface PrescriptorData {
    matricula: string;
    provincia: string;
    tipoMatricula: string;
}

export interface EfectorData {
    nombre: any;
    cuit: string;
}

export interface DiagnosticoData {
    codigo: string;
    descripcion: string;
}

export interface AtencionData {
    fechaAtencion: Date | null;
    horaAtencion: string | null;
    lugarAtencion: string | null;
}



export interface AcompananteData {
    nombre: string | null;
    apellido: string | null;
    tipoDocumento: string | null;
    nroDocumento: string | null;
    nroTelefono: string | null;
}

export interface DerivacionData {
    nombre: string | null;
    codigoPrestador: string | null;
}

export interface RecetaRequestModel {
    numero_copia?: string;
    firma_olografa?: string;
    beneficiario_nombre?: string;
    beneficiario_apellido?: string;
    beneficiario_sexo?: string;
    beneficiario_plan?: string;
    beneficiario_email?: string;
    beneficiario_dni?: string;
    beneficiario_fecha_nac?: string;
    credencial_numero?: string;
    estado?: string;
    codigo_diagnostico?: string;
    diagnostico?: string;
    diagnosticos?: Array<{
        codigo: string;
        descripcion: string;
        estandar: string;
    }>;
    fecha_receta?: string;
    fecha_dispensa_fin?: string;
    multi_dispensa?: boolean;
    financiador_cuit?: string;
    tipo_tratamiento?: string;
    extender_prescripcion?: boolean;
    periodo_autorizado?: string;
    prescriptor_nombre?: string;
    prescriptor_apellido?: string;
    prescriptor_provincia?: string;
    prescriptor_email?: string;
    prescriptor_copia?: boolean;
    prescriptor_domicilio?: string;
    prescriptor_telefono?: string;
    prescriptor_especialidad_descripcion?: string;
    prescriptor_nro_matricula?: number;
    prescriptor_cuit?: string;
    prescriptor_tipo_prescriptor?: string;
    location?: {
        lat: number;
        lng: number;
    };
    prescripcion?: {
        referencias_rx: Array<{
            cantidad_prescripta: number;
            droga_codigo: string;
            droga_descripcion: string;
            generico_presentacion: string;
            unidades: string;
            posologia: string;
            precauciones: string;
            items: Array<{
                cod_barras: string;
                cod_troquel: string;
                descripcion: string;
                estado: string;
                item_nro: number;
            }>;
            nro_linea: number;
        }>;
        determinaciones: any[];
        certificado: string;
        diagnostico_img: any[];
        certificado_digital?: boolean;
        certificado_digital_indicaciones?: string;
    };
}


export interface TransaccionesState {
    prestacionData: PrestacionAgregada[];
    prescriptorData: PrescriptorData | null;
    efectorData: EfectorData | null;
    diagnosticoData: DiagnosticoData | null;
    acompananteData: AcompananteData | null;
    derivacionData: DerivacionData | null;
    atencionData: AtencionData | null;
    recetaRequest: RecetaRequestModel | null;
    isReadonly: boolean;
}
